const DATA_SAVED = "extragestor/ventas/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/ventas/RESET_DATA_SAVED";

const FETCH_LISTA_COLEGIOS = "extragestor/ventas/FETCH_LISTA_COLEGIOS";
const RESET_LISTA_COLEGIOS = "extragestor/ventas/RESET_LISTA_COLEGIOS";

const ITEMS_TOTALES = "extragestor/ventas/ITEMS_TOTALES";
const PAGINAS_TOTALES = "extragestor/ventas/PAGINAS_TOTALES";
const ITEMS_POR_PAGINA = "extragestor/ventas/ITEMS_POR_PAGINA";
const PAGINA_ACTUAL = "extragestor/ventas/PAGINA_ACTUAL";
const INICIOS_DE_PAGINA = "extragestor/ventas/INICIOS_DE_PAGINA";
const SELECCIONAR_COLEGIO = "extragestor/ventas/SELECCIONAR_COLEGIO";
const QUITAR_COLEGIO_SELECCIONADO =
  "extragestor/ventas/QUITAR_COLEGIO_SELECCIONADO";
const ADDED_PERSONAS_CONTACTO = "extragestor/ventas/ADDED_PERSONAS_CONTACTO";
const REMOVED_PERSONAS_CONTACTO =
  "extragestor/ventas/REMOVED_PERSONAS_CONTACTO";
const CHANGED_PERSONAS_CONTACTO =
  "extragestor/ventas/CHANGED_PERSONAS_CONTACTO";
const LIMPIAR_PERSONAS_CONTACTO =
  "extragestor/ventas/LIMPIAR_PERSONAS_CONTACTO";
const DETACH_LISTENER = "DETACH_LISTENER";

const ADDED_ACCIONES_VENTA = "extragestor/ventas/ADDED_ACCIONES_VENTA";
const REMOVED_ACCIONES_VENTA = "extragestor/ventas/REMOVED_ACCIONES_VENTA";
const CHANGED_ACCIONES_VENTA = "extragestor/ventas/CHANGED_ACCIONES_VENTA";
const LIMPIAR_ACCIONES_VENTA = "extragestor/ventas/LIMPIAR_ACCIONES_VENTA";

const SET_PROVINCIA_ACTIVA = "extragestor/ventas/SET_PROVINCIA_ACTIVA";
const RESET_PROVINCIA_ACTIVA = "extragestor/ventas/RESET_PROVINCIA_ACTIVA";

const SET_COLEGIO_BUSCADO = "extragestor/ventas/SET_COLEGIO_BUSCADO";
const RESET_COLEGIO_BUSCADO = "extragestor/ventas/RESET_COLEGIO_BUSCADO";

const OBTENER_NOMBRE_COLEGIOS = "extragestor/ventas/OBTENER_NOMBRE_COLEGIOS";
const LIMPIAR_NOMBRE_COLEGIOS = "extragestor/ventas/LIMPIAR_NOMBRE_COLEGIOS";

const OBTENER_LOCALIDADES = "extragestor/ventas/OBTENER_LOCALIDADES";
const LIMPIAR_LOCALIDADES = "extragestor/ventas/LIMPIAR_LOCALIDADES";

const SET_LOCALIDAD = "extragestor/ventas/SET_LOCALIDAD";
const RESET_LOCALIDAD = "extragestor/ventas/RESET_LOCALIDAD";

const TIPO = "extragestor/ventas/TIPO";

const RESULTADO_ACCION_MAIL = {
  SIN_RESPUESTA: "Sin respuesta",
  CON_RESPUESTA: "Con respuesta"
};

const RESULTADO_ACCION_TELEFONO = {
  SIN_CITA: "No cita",
  CON_CITA: "Cita"
};

const RESULTADO_ACCION_VISITA = {
  SIN_CITA: "No cita",
  CON_CITA: "Cita",
  DATOS: "Datos Obtenidos",
  NO_DATOS: "No datos"
};

const RESULTADO_ACCION_EXTERNO = {
  SIN_CITA: "No cita",
  CON_CITA: "Cita",
  DATOS: "Datos Obtenidos",
  NO_DATOS: "No datos"
};

const ESTADO_VENTA = {
  NO_CONTACTADO: "No Contactado",
  RECHAZADO: "Rechazado / No Interesa",
  EN_PROCESO: "En proceso",
  INTERESADO_POSTPONER: "Interesado más adelante",
  ULTIMANDO: "Ultimando",
  VENTA: "Venta"
};

/* --- */
export {
  FETCH_LISTA_COLEGIOS,
  RESET_LISTA_COLEGIOS,
  ITEMS_TOTALES,
  PAGINAS_TOTALES,
  ITEMS_POR_PAGINA,
  PAGINA_ACTUAL,
  INICIOS_DE_PAGINA,
  DATA_SAVED,
  RESET_DATA_SAVED,
  SELECCIONAR_COLEGIO,
  QUITAR_COLEGIO_SELECCIONADO,
  ADDED_PERSONAS_CONTACTO,
  REMOVED_PERSONAS_CONTACTO,
  CHANGED_PERSONAS_CONTACTO,
  LIMPIAR_PERSONAS_CONTACTO,
  DETACH_LISTENER,
  RESULTADO_ACCION_MAIL,
  RESULTADO_ACCION_TELEFONO,
  RESULTADO_ACCION_VISITA,
  RESULTADO_ACCION_EXTERNO,
  ESTADO_VENTA,
  ADDED_ACCIONES_VENTA,
  REMOVED_ACCIONES_VENTA,
  CHANGED_ACCIONES_VENTA,
  LIMPIAR_ACCIONES_VENTA,
  TIPO,
  SET_PROVINCIA_ACTIVA,
  RESET_PROVINCIA_ACTIVA,
  OBTENER_NOMBRE_COLEGIOS,
  LIMPIAR_NOMBRE_COLEGIOS,
  SET_COLEGIO_BUSCADO,
  RESET_COLEGIO_BUSCADO,
  OBTENER_LOCALIDADES,
  LIMPIAR_LOCALIDADES,
  SET_LOCALIDAD,
  RESET_LOCALIDAD
};



// WEBPACK FOOTER //
// ./src/ducks/ventas/types.js